import React from 'react';

interface BatimentCardProps {
  batiment: any;
  onEdit: (batiment: any) => void;
  onDelete: (batiment: any) => void;
  isSelected?: boolean;
  onToggleSelection?: () => void;
  canEdit?: boolean;
  canDelete?: boolean;
  canBulk?: boolean;
}

const BatimentCard: React.FC<BatimentCardProps> = ({ 
  batiment, 
  onEdit, 
  onDelete, 
  isSelected = false, 
  onToggleSelection,
  canEdit = false,
  canDelete = false,
  canBulk = false
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 hover:shadow-md transition-shadow">
      {/* En-tête avec case à cocher, nom et actions */}
      <div className="flex items-start gap-2 mb-2">
        {/* Case à cocher à gauche */}
        {onToggleSelection && canBulk && (
          <label className="flex-shrink-0 cursor-pointer mt-0.5">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={onToggleSelection}
              className="form-checkbox h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
              onClick={(e) => e.stopPropagation()}
            />
          </label>
        )}
        
        {/* Contenu principal */}
        <div className="flex items-start justify-between gap-2 flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <h3 className="font-semibold text-gray-900 text-sm truncate">{batiment.nom}</h3>
            {batiment.trigram && (
              <span className="px-2 py-0.5 text-xs font-medium rounded bg-orange-100 text-orange-800 flex-shrink-0">
                {batiment.trigram}
              </span>
            )}
          </div>
          {(canEdit || canDelete) && (
            <div className="flex gap-1 flex-shrink-0">
              {canEdit && (
                <button
                  onClick={() => onEdit(batiment)}
                  className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50"
                  title="Modifier"
                >
                  ✏️
                </button>
              )}
              {canDelete && (
                <button
                  onClick={() => onDelete(batiment)}
                  className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50"
                  title="Supprimer"
                >
                  🗑️
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Site parent */}
      {batiment.site && (
        <div className="flex items-center gap-1.5 text-xs text-gray-600 mb-2">
          <span className="flex-shrink-0">📍</span>
          <span className="truncate">{batiment.site.nom}</span>
        </div>
      )}

      {/* Nombre d'étages */}
      {batiment.nombreEtages && (
        <div className="flex items-center gap-1.5 text-xs text-gray-600 mb-2">
          <span className="flex-shrink-0">🏢</span>
          <span>{batiment.nombreEtages} étage{batiment.nombreEtages > 1 ? 's' : ''}</span>
        </div>
      )}

      {/* Statistiques */}
      <div className="flex items-center gap-3 text-xs text-gray-500">
        <span className="flex items-center gap-1">
          <span>🚪</span>
          <span>{batiment.pieces?.length || 0} pièces</span>
        </span>
        <span className="flex items-center gap-1">
          <span>📦</span>
          <span>{batiment.pieces?.reduce((total: number, piece: any) => 
            total + (piece.zones?.length || 0) + (piece.boxes?.length || 0), 0) || 0} zones/boxes</span>
        </span>
      </div>
    </div>
  );
};

export default BatimentCard;
